module.exports = __webpack_public_path__ + "assets/UndoBtn.031098d1692fa96a1e44c1acd2e53b83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/play-screen-ui/UndoBtn.svg
// module id = 870
// module chunks = 0